import MainComponent from "components/Main";
import PropTypes from 'prop-types';

import { ReactComponent as StarIcon } from 'icons/components/star.svg';

import './themes/default.less';

export default class Rating extends MainComponent {
    static propTypes = {
        value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    };
    static defaultProps = {
        value: "",
    };

    stars = [1, 2, 3, 4, 5];

    onStarClick(value, e) {
        this._helper.stopEvent(e);
    }

    render() {
        //const value = Math.round(this.props.value || 0);
        // remove later
        const value = this._helper.number.random(0, 5);

        return (
            <div className="ratingItem flex gap4">
                {this.stars.map(i => {
                    const cl = value >= i ? " active" : "";

                    return <StarIcon key={i} className={"star hand" + cl} onClick={this.onStarClick.bind(this, i)} />;
                })}
            </div>
        );
    }
}
